import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EwalletService {
  url: string = `${environment.API_SERVER}`;
  baseUrl: string = `${environment.API_SERVER}/finance/e-wallet`;
  financeUrl: string = environment.FINANCE_API_SERVER;
  constructor(private _http: HttpClient) {}

  withdrawalRequest(payload) {
    return this._http.post(this.baseUrl + `/withdrawal-request/`, payload.body);
  }

  payInvoice(payload) {
    return this._http.post(this.baseUrl + `/pay-invoice/`, payload.body);
  }
  payNonInvoice(payload) {
    return this._http.post(this.baseUrl + `/complete-payment/`, payload.body);
  }

  getAccountDetails(payload) {
    return this._http.get(this.baseUrl + `/details/`, {
      params: payload.params,
    });
  }

  getBalances(payload) {
    return this._http.get(this.baseUrl + `/balances/`, {
      params: payload.params,
    });
  }
  getCurrencies(payload) {
    return this._http.get(this.url + `/finance/config/currencies/`, {
      params: payload.params,
    });
  }
  getTermsAndCondition() {
    return this._http.get(this.baseUrl + `/terms-and-conditions/`);
  }
  activateCurrency(payload) {
    return this._http.post(this.baseUrl + `/activate-currency/`, payload.body);
  }
  activateCompany(payload) {
    return this._http.post(this.baseUrl + `/activate-company/`, payload.body);
  }
  getBanks(payload) {
    return this._http.get(
      this.baseUrl + `/applicable-banks/${payload.currency}/`
    );
  }

  deactivateAccount(payload) {
    return this._http.post(this.baseUrl + `/deactivate-company/`, payload.body);
  }

  fundWallet(payload) {
    return this._http.post(this.baseUrl + `/fund/`, payload.body);
  }

  requestWithdrawal(payload) {
    return this._http.post(this.baseUrl + `/withdrawal-request/`, payload.body);
  }

  getBankDetails(customerWalletId, payload) {
    return this._http.get(
      this.baseUrl + `/bank-details-history/${customerWalletId}/active`,
      {
        params: payload.params,
      }
    );
  }

  changeBankDetails(customerWalletId, payload) {
    return this._http.post(
      this.baseUrl +
        `/bank-details-history/${customerWalletId}/request-update/`,
      payload.body
    );
  }

  getWalletDetails(payload) {
    return this._http.get(this.baseUrl + `/details/?nccId=${payload.nccId}`);
  }
  get2FADetails(payload) {
    return this._http.get(this.url + `/two_factor/${payload.appUserId}/data`);
  }
  closeAccount(payload) {
    // return this._http.post(
    //   this.baseUrl + `/close-account/`,
    //   payload.body
    // );
  }

  getAppConfigs(payload) {
    return this._http.get(this.url + '/admin/app_configs/', {
      params: payload.params,
    });
  }
  get2FAConfig(payload): Observable<any> {
    return this._http.get(`${this.url}/public/app-config/${payload.configId}`);
  }
  getBalancesByCurrency(payload) {
    return this._http.get(
      this.baseUrl + `/balances-by-currency/?currencyId=${payload.currencyId}`,
      {
        params: payload.params,
      }
    );
  }

  exportEWalletTransactions(payload) {
    return this._http
      .get(
        this.baseUrl +
          `/transactions/export/?nccId=${payload.nccId}&currencyId=${payload.currencyId}`,
        { params: payload.params }
      )
      .pipe(
        switchMap((res) => {
          const id = res['data'];
          const eventSource = new EventSource(
            this.financeUrl + `/public/stream-event/upload-progress/${id}/`
          );

          return new Observable<any>((observer) => {
            eventSource.onmessage = (event) => {
              const eventData = JSON.parse(event.data);
              if (eventData.progress == 100) {
                this._http
                  .get(
                    this.financeUrl + `/public/media/?media=${eventData.file}`,
                    {
                      responseType: 'blob',
                    }
                  )
                  .subscribe((fileBlob) => {
                    observer.next(fileBlob);
                    observer.complete();
                    eventSource.close();
                  });
              }
            };

            eventSource.onerror = (error) => {
              observer.error(error);
              eventSource.close();
            };
          });
        })
      );
  }

  getEWalletTransactions(payload) {
    return this._http.get(
      this.baseUrl +
        `/transactions/?nccId=${payload.nccId}&currencyId=${payload.currencyId}`,
      {
        params: payload.params,
      }
    );
  }

  getPendingEWalletFundingTransactions(payload) {
    return this._http.get(
      this.baseUrl +
        `/wallet-funding/pending/?nccId=${payload.nccId}&currencyId=${payload.currencyId}`,
      {
        params: payload.params,
      }
    );
  }

  getPendingEWalletWithdrawalTransactions(payload) {
    return this._http.get(
      this.baseUrl +
        `/withdrawal-requests/pending/?nccId=${payload.nccId}&currencyId=${payload.currencyId}&appUserId=${payload.appUserId}`,
      {
        params: payload.params,
      }
    );
  }

  getWithdrawalCharges() {
    return this._http.get(this.baseUrl + '/withdrawal-charges/');
  }

  getWithdrawalTaxPercent() {
    return this._http.get(this.baseUrl + '/withdrawal-tax-percent/');
  }

  getWithdrawalRequests(payload: any) {
    return this._http.get(
      this.baseUrl +
        `/withdrawal-requests/?nccId=${payload.nccId}&currencyId=${payload.currencyId}&appUserId=${payload.appUserId}`,
      {
        params: payload.params,
      }
    );
  }

  getCurrencyWithdrawalRequests(payload) {
    return this._http.get(
      this.baseUrl +
        `/currency-withdrawal-requests/?currencyId=${payload.currencyId}&appUserId=${payload.appUserId}`,
      {
        params: payload.params,
      }
    );
  }

  getWithdrawalRequestDetailsById(payload) {
    return this._http.get(
      this.baseUrl + `/withdrawal-request/${payload.withdrawalRequestId}`,
      {
        params: payload.params,
      }
    );
  }

  getWithdrawalRequestDocumentsById(payload) {
    return this._http.get(
      this.baseUrl +
        `/withdrawal-requests/${payload.withdrawalRequestId}/documents/`,
      {
        params: payload.params,
      }
    );
  }

  cancelWithdrawalRequest(payload) {
    return this._http.post(
      this.baseUrl + `/cancel-withdrawal-request/`,
      payload.body
    );
  }

  getBankDetailsHistory(payload) {
    return this._http.get(
      this.baseUrl +
        `/bank-details-history/?customerWalletId=${payload.customerWalletId}&appUserId=${payload.appUserId}`,
      {
        params: payload.params,
      }
    );
  }

  getCurrencyBankDetailsHistory(payload) {
    return this._http.get(
      this.baseUrl +
        `/company/bank-details-history/?nccId=${payload.nccId}&currencyId=${payload.currencyId}&appUserId=${payload.appUserId}`,
      {
        params: payload.params,
      }
    );
  }

  cancelBankDetailsHistory(payload) {
    return this._http.post(
      this.baseUrl + `/cancel-bank-details-history/`,
      payload.body
    );
  }
}
